import { createClient } from '@supabase/supabase-js';

// Get environment variables
const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

// Debug logging for environment variables
console.log('Supabase URL:', supabaseUrl || 'NOT FOUND');
console.log('Supabase key length:', supabaseAnonKey ? supabaseAnonKey.length : 'NOT FOUND');

// Validate environment variables
if (!supabaseUrl || !supabaseAnonKey) {
  console.error('🚨 Missing Supabase credentials. Make sure your .env file contains:');
  console.error('VITE_SUPABASE_URL=your-project-url');
  console.error('VITE_SUPABASE_ANON_KEY=your-anon-key');
  throw new Error('Missing Supabase credentials in environment variables');
}

// Create a fetch wrapper with better error handling
const customFetch = async (url: RequestInfo | URL, options?: RequestInit) => {
  try {
    // Log request details for debugging (avoid logging sensitive data in production)
    if (import.meta.env.DEV) {
      console.log(`Fetching: ${url.toString()}`);
    }
    
    // Use standard fetch API
    const response = await fetch(url, options);
    
    // Don't throw errors for 4xx/5xx responses
    // Supabase needs to handle these responses itself
    return response;
  } catch (error) {
    // Only log network/connection errors
    console.error('Supabase network error:', error);
    throw error;
  }
};

// Create the Supabase client with options specifically configured to avoid 
// automatic profile creation issues
const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  global: {
    fetch: customFetch
  },
  auth: {
    storage: localStorage, // Use localStorage instead of sessionStorage for better persistence
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true
  },
  db: {
    schema: 'public'
  }
});

console.log('✅ Supabase client initialized successfully');

export { supabase };
export default supabase;